<div class='floating-bouton' [hidden]="(selectedOutils$ | async) === false">
  <div class="btn-group-vertical" role="group" aria-label="Groupe de boutons en colonne">

    <button
      [hidden]="((selectedDessinOutilsSeulementZone$| async) === true || (selectedModeValorisation$ | async) === false) && ((selectedDessinOutilsSeulementZone$| async) === false  || (selectedTypePoseCurrentZone$ | async) === false)"
      (click)="toggleCadastreMode()"
      [ngClass]="(isCadastreEnabled$ | async) ? 'btn-primary' : 'btn-secondary'"
      class='btn custom-outils'
      title='Activer/Désactiver le mode cadastre'>
        <img src="assets/images/logos/logo-cadastre.png" alt="Cadastre" style="width: 54px; height: 55px;">
    </button>
    <button
      [hidden]="((selectedDessinOutilsSeulementZone$| async) === true || (selectedModeValorisation$ | async) === false) && ((selectedDessinOutilsSeulementZone$| async) === false  || (selectedTypePoseCurrentZone$ | async) === false)"
      (click)="activateMeasureDistanceToolGeneric()"
      [ngClass]="(activeTool$ | async) === toolEnum.GenericDistance ? 'btn-primary' : 'btn-secondary'"
      class='btn custom-outils'
      title='Mesurer une distance'>
        <i class="bi bi-rulers custom-outils-bi"></i>
    </button>

    <button
      [hidden]="((selectedDessinOutilsSeulementZone$ | async) === true || (selectedModeValorisation$ | async) === false) && ((selectedDessinOutilsSeulementZone$ | async) === false || (selectedTypePoseCurrentZone$ | async) === false)"
      (click)="toggleNetworkTools()"
      [ngClass]="showNetworkTools ? 'btn-primary' : 'btn-secondary'"
      class='btn custom-outils'
      title='Afficher les couches Enedis'>
      <img src="assets/images/logos/enedis.png" alt="Enedis" style="width: 54px; height: 55px;">
    </button>

    <button
      *ngIf="showNetworkTools"
      [hidden]="((selectedDessinOutilsSeulementZone$ | async) === true || (selectedModeValorisation$ | async) === false) && ((selectedDessinOutilsSeulementZone$ | async) === false || (selectedTypePoseCurrentZone$ | async) === false)"
      (click)="toggleEnedisMode()"
      [ngClass]="(isEnedisEnabled$ | async) ? 'btn-primary' : 'btn-secondary'"
      class='btn custom-outils'
      title='Lignes Enedis BT souterraines'>
      <i class="bi bi-hexagon-fill custom-outils-bi icon-blue"></i>
    </button>

    <button
      *ngIf="showNetworkTools"
      [hidden]="((selectedDessinOutilsSeulementZone$ | async) === true || (selectedModeValorisation$ | async) === false) && ((selectedDessinOutilsSeulementZone$ | async) === false || (selectedTypePoseCurrentZone$ | async) === false)"
      (click)="toggleHtaMode()"
      [ngClass]="(isHtaEnabled$ | async) ? 'btn-primary' : 'btn-secondary'"
      class='btn custom-outils'
      title='Lignes HTA souterraines'>
      <i class="bi bi-hexagon-fill custom-outils-bi icon-purple"></i>
    </button>

    <button
      *ngIf="showNetworkTools"
      [hidden]="((selectedDessinOutilsSeulementZone$ | async) === true || (selectedModeValorisation$ | async) === false) && ((selectedDessinOutilsSeulementZone$ | async) === false || (selectedTypePoseCurrentZone$ | async) === false)"
      (click)="togglePostesMode()"
      [ngClass]="(isPostesEnabled$ | async) ? 'btn-primary' : 'btn-secondary'"
      class='btn custom-outils'
      title='Postes electriques HTA/BT'>
      <i class="bi bi-geo-alt-fill custom-outils-bi icon-blue"></i>
    </button>

    <button
      [hidden]="((activeZoneId$ | async) < 7 && (selectedTypePoseCurrentZone$ | async) === false) || ((activeZoneId$ | async) === 3 && (selectedModeValorisation$ | async) === false)"
      (click)='disableTools()'
      [ngClass]="(activeTool$ | async) === toolEnum.None ? 'btn-primary' : 'btn-secondary'"
      class='btn custom-outils'
      title='Modifier ou voir les dessins'>
      <i class="bi bi-eye-fill custom-outils-bi"></i>
    </button>

    <button
      [hidden]="isModeValorisationTabActive || (selectedDessinOutilsSeulementZone$ | async) === false || (selectedTypePoseCurrentZone$ | async) === false"
      (click)='activateMeasureAreaTool()'
      [ngClass]="(activeTool$ | async) === toolEnum.Surface ? 'btn-primary' : 'btn-secondary'"
      class='btn custom-outils'
      title='Dessiner la ou les surfaces'>
      <i class="bi bi-square custom-outils-bi"></i>
    </button>

    <button
      [hidden]="isModeValorisationTabActive || (selectedDessinOutilsSeulementZone$ | async) === false || (selectedTypePoseCurrentZone$ | async) === false"
      (click)='activateMeasureAzimuthTool()'
      [ngClass]="(activeTool$ | async) === toolEnum.Azimuth ? 'btn-primary' : 'btn-secondary'"
      class='btn custom-outils'
      title="Dessiner l'azimuth">
      <i class="bi bi-compass custom-outils-bi"></i>
    </button>

    <button
      *ngIf="isRaccordementTabActive"
      [hidden]="(selectedDessinOutilsSeulementZone$ | async) === true || (selectedModeValorisation$ | async) === false"
      (click)='activateRaccordementSquareTool()'
      [ngClass]="((activeTool$ | async) === toolEnum.MeterBt || (activeTool$ | async) === toolEnum.TransformerHt) ? 'btn-primary' : 'btn-secondary'"
      class='btn custom-outils'
      title='Dessiner le compteur ou le poste transfo'>
      <img
        [src]="((activeTool$ | async) === toolEnum.MeterBt || (activeTool$ | async) === toolEnum.TransformerHt)
          ? 'assets/images/logos/logo_compteur_PDL_white.png'
          : 'assets/images/logos/logo_compteur_PDL.png'"
        alt="Compteur PDL"
        class="counter-tool-logo">
    </button>

    <button
      [hidden]="(selectedDessinOutilsSeulementZone$| async) === false || (selectedTypePoseCurrentZone$ | async) === false"
      (click)='activateExclusionTool()'
      [ngClass]="(activeTool$ | async) === toolEnum.Exclusion ? 'btn-primary' : 'btn-secondary'"
      class='btn custom-outils'
      title="Dessiner une zone d'exclusion (sans panneaux)">
        <i class="bi bi-x-square custom-outils-bi"></i>
    </button>

    <button
      *ngIf="shouldShowTrenchTools('all')"
      [hidden]="(selectedDessinOutilsSeulementZone$ | async) === true || (selectedModeValorisation$ | async) === false"
      (click)='activatePrivateTrenchEnrobeeTool()'
      [ngClass]="(activeTool$ | async) === toolEnum.PrivateTrenchEnrobee ? 'btn-primary' : 'btn-secondary'"
      class='btn custom-outils'
      title='Dessiner la tranchee enrobee'>
      <span class="trench-arrow trench-arrow-solid">
        <span class="trench-arrow-line"></span>
        <span class="trench-arrow-head"></span>
      </span>
    </button>

    <button
      *ngIf="shouldShowTrenchTools('restricted')"
      [hidden]="(selectedDessinOutilsSeulementZone$ | async) === true || (selectedModeValorisation$ | async) === false"
      (click)='activatePrivateTrenchNaturelTool()'
      [ngClass]="(activeTool$ | async) === toolEnum.PrivateTrenchNaturel ? 'btn-primary' : 'btn-secondary'"
      class='btn custom-outils'
      title='Dessiner la tranchee terrain naturel'>
      <span class="trench-arrow trench-arrow-large-dash">
        <span class="trench-arrow-line"></span>
        <span class="trench-arrow-head"></span>
      </span>
    </button>

    <button
      *ngIf="shouldShowTrenchTools('restricted')"
      [hidden]="(selectedDessinOutilsSeulementZone$ | async) === true || (selectedModeValorisation$ | async) === false"
      (click)='activatePrivateTrenchToitureTool()'
      [ngClass]="(activeTool$ | async) === toolEnum.PrivateTrenchToiture ? 'btn-primary' : 'btn-secondary'"
      class='btn custom-outils'
      title='Dessiner la tranchee passage en toiture'>
      <span class="trench-arrow trench-arrow-small-dash">
        <span class="trench-arrow-line"></span>
        <span class="trench-arrow-head"></span>
      </span>
    </button>

    <button
      [hidden]="!isRaccordementTabActive && (((activeZoneId$ | async) < 7 && (selectedTypePoseCurrentZone$ | async) === false) || ((activeZoneId$ | async) === 6 && (selectedModeValorisation$ | async) === false))"
      (click)='activateDeleteTool()'
      [ngClass]="(activeTool$ | async) === toolEnum.Delete ? 'btn-primary' : 'btn-secondary'"
      class='btn custom-outils'
      title='Supprimer le ou les dessins'>
      <i class="bi bi-trash custom-outils-bi"></i>
    </button>

    <button
      [hidden]="(((activeZoneId$ | async) < 7 && (selectedTypePoseCurrentZone$ | async) === false) || (activeZoneId$ | async) === 7)"
      (click)='resetCurrentZone()'
      class='btn btn-reset custom-outils'
      title='Suppression du type de pose selectionne avec suppression de tous les dessins'>
      <i class="bi bi-x-lg custom-outils-bi"></i>
    </button>

    <button
      *ngIf="isRaccordementTabActive"
      [hidden]="(selectedDessinOutilsSeulementZone$ | async) === true || (selectedModeValorisation$ | async) === false"
      (click)='resetDessinRaccordement()'
      class='btn btn-reset custom-outils'
      title='Suppression de tous les raccordements dessines'>
      <i class="bi bi-x-lg custom-outils-bi"></i>
    </button>
  </div>
</div>
